export const isValidJSON = (jsonString) => {
  try {
    JSON.parse(jsonString)
    return true
  } catch (error) {
    return false
  }
}

export const deserialize = (value) => {
  return (value && isValidJSON(value) && JSON.parse(value)) || {}
}
